const popuHTML = `
<div role="alertdialog" data-state="open" class="fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border border-border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg" tabindex="-1" style="pointer-events: auto;">
  <div class="flex flex-col space-y-2 text-center sm:text-left">
    <h2 class="text-lg font-semibold" id="alert-title"></h2>
    <p class="text-sm text-muted-foreground" id="alert-text"></p>
  </div>
  <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
    <button type="button" class="button outlined" id="alert-cancel-btn"></button>
    <button type="button" class="button primary" id="alert-confirm-btn"></button>
  </div>
</div>
`.replace(/(^|\n)\s*/g, '')

export default class AlertPopup {
  constructor(options){
    this.container = document.createElement('div')
    this.container.dataset.state = 'open'
    this.container.className = "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
    this.container.innerHTML = popuHTML

    this.setTitle(options.title)
    this.setText(options.text)
    this.setCancelBtn(options.cancelBtnText)
    this.setConfirmBtn(options.acceptBtnText)
    if(options.showCancelButton === false) this.removeCancelBtn()

    this._onConfirm = options.onConfirm || null
    this._resolve = null

    this.container.querySelector('#alert-cancel-btn').addEventListener('click', () => this.dismiss({ wasConfirmed: false }))
    this.container.querySelector('#alert-confirm-btn').addEventListener('click', () => this.onConfirm())
  }

  getPopup(){
    return this.container.querySelector('[role="alertdialog"]')
  }

  setTitle(t){ this.container.querySelector('#alert-title').textContent = t }
  setText(t){ this.container.querySelector('#alert-text').textContent = t }
  setCancelBtn(l){ this.container.querySelector('#alert-cancel-btn').textContent = l }
  setConfirmBtn(l){ this.container.querySelector('#alert-confirm-btn').textContent = l }
  removeCancelBtn(){ this.container.querySelector('#alert-cancel-btn').remove() }

  fire(){
    document.body.appendChild(this.container)
    return new Promise((resolve) => {
      this._resolve = resolve
    })
  }

  dismiss(result = { wasConfirmed: false }){
    this.container.dataset.state = 'closed'
    this.getPopup().dataset.state = 'closed'
    setTimeout(() => {
      this.container.remove()
      if(this._resolve) this._resolve(result) // after dismiss resolver
    }, 150)
  }

  onConfirm(){
    const btn = this.container.querySelector('#alert-confirm-btn')
    btn.classList.add('disabled')

    if (this._onConfirm) {
      // callback set
      this._onConfirm(() => { // == done() aka resolver
        this.dismiss({ wasConfirmed: true })
      })
    } else {
      // immediate confirm
      this.dismiss({ wasConfirmed: true })
    }
  }
}